var map = {
	"./1chaise.webp": 7732,
	"./2chaise.webp": 1894,
	"./3chaise.webp": 9642,
	"./IMG_20220202_141014.webp": 7546,
	"./IMG_20220305_091502.webp": 6596,
	"./IMG_20220305_091703.webp": 1939,
	"./fauteuil_studio_1930_1.webp": 3229,
	"./fauteuil_studio_1930_2.webp": 898,
	"./fauteuil_studio_1930_3.webp": 3896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6290;